import { Helmet } from "react-helmet-async";
import { brand } from "@/config/brand";

/**
 * Global JSON-LD schemas injected on every page:
 * - Organization
 * - WebSite (with SearchAction for sitelinks search box)
 */
const GlobalJsonLd = () => {
  const origin = typeof window !== "undefined" ? window.location.origin : `https://${brand.domain}`;

  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${origin}/#organization`,
    name: brand.name,
    url: origin,
    logo: `${origin}/pwa-512x512.png`,
    description: brand.description,
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      url: `${origin}/צור-קשר`,
      availableLanguage: "Hebrew",
    },
    sameAs: [],
  };

  const webSite = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${origin}/#website`,
    name: brand.name,
    url: origin,
    description: brand.description,
    inLanguage: "he",
    publisher: { "@id": `${origin}/#organization` },
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${origin}/?search={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(webSite)}</script>
    </Helmet>
  );
};

export default GlobalJsonLd;
